import api from "../axiosIntercepture";

export const getInventoryListAPI = async (page, pageSize) => {
    try {
        const response = await api.post(`/ordermanagement/getInventoryList?page=${page+1}&pageSize=${pageSize}`);
        return response?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


export const saveInventoryAPI = async (value) => {
    try {
        const response = await api.post('/ordermanagement/createInventory', value);
        return response?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}


export const updateInventoryAPI = async (value,id) => {
    try {
        const response = await api.post(`/ordermanagement/updateInventory/${id}`, value);
        return response?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}